import * as React from "react";
import { InputContainerProps } from "../elements/InputContainer";
import { composeRefs } from "../util";

type Props = React.HTMLAttributes<HTMLTextAreaElement> & InputContainerProps;

const withAutoHeightInput = (
  Component: any
): React.ForwardRefExoticComponent<any> => {
  return React.forwardRef(function WithAutoHeightInput(
    { onChange, ...rest }: Props,
    ref: any
  ) {
    const [initHeight, setInitHeight] = React.useState<number>(0);
    const inputRef = React.useRef<HTMLTextAreaElement>(null);

    React.useLayoutEffect(() => {
      setInputHeight();
      setInitHeight(inputRef.current!.scrollHeight);
    }, []);

    const setInputHeight = () => {
      const element = inputRef.current!;
      element.style.height = initHeight + "px";
      element.style.height = element.scrollHeight + "px";
    };

    const handleChange = (evt: any) => {
      if (onChange) {
        onChange(evt);
      }
      setInputHeight();
    };

    return (
      <Component
        ref={composeRefs(ref, inputRef)}
        onChange={handleChange}
        {...rest}
      />
    );
  });
};

export default withAutoHeightInput;
